import {call, put, takeLatest} from 'redux-saga/effects'
import {
  SEND_MESSAGE_REQUESTED, 
  GET_NOTIFICATIONS_LIST_REQUESTED,
} from '../actions/actionTypes'
import {messages} from '../../helpers/messages'
import {notificationService} from '../../services/notification-service'

import {
    requestForSendMessageSuccess,
    requestForSendMessageFailed,
    getNotificationsListSuccess,
    getNotificationsListFailed,
} from '../actions/notificationAction'

const sendMessage = async (data) =>
  await notificationService
    .sendMessageToClients(data)
    .then(({data}) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

  const getNotificationsList = async (data) =>
    await notificationService
      .getNotifications(data)
      .then(({data}) => data)
      .catch(error => {
        if (error.response) {
          let errorData = error.response.data
          let commonError = messages["0"]
          if (errorData.errorCode) {
            commonError = messages[errorData.errorCode]
          }
          throw commonError
        }
      })

function* fetchSendMessage ({payload}) {
  try {
    const messages = yield call(() => sendMessage(payload))
    yield put(requestForSendMessageSuccess(messages))
  } catch (error) {
    yield put(requestForSendMessageFailed(error))
  }
}

function* fetchGetNotificationsList ({payload}) {
  try {
    const notifications = yield call(getNotificationsList, payload)
    yield put(getNotificationsListSuccess(notifications))
  } catch (error) {
    yield put(getNotificationsListFailed(error))
  }
}

function* sendMessageSaga () {
  yield takeLatest(SEND_MESSAGE_REQUESTED, fetchSendMessage)
}

function* getNotificationsListSaga () {
  yield takeLatest(GET_NOTIFICATIONS_LIST_REQUESTED, fetchGetNotificationsList)
}

export {
    sendMessageSaga,
    getNotificationsListSaga,
}
